import { StubTokenDefinition } from "./stub/StubTokenDefinition";

const permissionListWithSongsheetsRead = ["songsheets:read"];

export const noCrewPayingUser = new StubTokenDefinition(
  "NoCrewPayingUser",
  permissionListWithSongsheetsRead,
);
export const nomintOnlyUserTokenDefinition = new StubTokenDefinition(
  "NomintOnlyUser",
);
export const adorayOnlyUserTokenDefinition = new StubTokenDefinition(
  "AdorayOnlyUser",
);
export const adorayLuzernOnlyUserTokenDefinition = new StubTokenDefinition(
  "AdorayLuzernOnlyUser",
);
export const payingAdorayLuzernOnlyUserTokenDefinition =
  new StubTokenDefinition(
    "PayingAdorayLuzernOnlyUser",
    permissionListWithSongsheetsRead,
  );
export const adorayBernOnlyUserTokenDefinition = new StubTokenDefinition(
  "AdorayBernOnlyUser",
);

export const payingAllOrganizationsUserTokenDefinition =
  new StubTokenDefinition(
    "PayingAllOrganizationsUser",
    permissionListWithSongsheetsRead,
  );

export function permissionsFor(
  stubToken: StubTokenDefinition,
): readonly string[] {
  const fakeTokenEntry = auth0UserStub.find(
    (f) => f.tokenWithoutPrefix === stubToken.tokenWithoutPrefix,
  );
  return fakeTokenEntry ? fakeTokenEntry.content.permissions : [];
}

//keep in sync with SecurityTokenUtils on server side
export const auth0UserStub: StubTokenDefinition[] = [
  noCrewPayingUser,
  nomintOnlyUserTokenDefinition,
  adorayOnlyUserTokenDefinition,
  adorayLuzernOnlyUserTokenDefinition,
  payingAdorayLuzernOnlyUserTokenDefinition,
  adorayBernOnlyUserTokenDefinition,
  new StubTokenDefinition("WallisOnlyUser"),
  new StubTokenDefinition("AdorayNomintUser"),
  payingAllOrganizationsUserTokenDefinition,
  new StubTokenDefinition(
    "PayingAdorayNomintSecondUser",
    permissionListWithSongsheetsRead,
  ),
  new StubTokenDefinition("AdorayWallisUser"),
  new StubTokenDefinition("WallisNomintUser"),
  new StubTokenDefinition("NomintAdorayWallisUser"),
];
